import React from 'react'
import { UserPermission } from 'src/constants/user'
import { useSelector } from 'react-redux'
import { getAccessInfo } from 'src/selectors/user'
import { Navigate } from 'react-router-dom'
import { ROUTES } from 'src/constants/routes'

export const NavigateToInitialRoute = () => {
  const accessInfo = useSelector(getAccessInfo)

  if (!accessInfo) {
    return null
  }

  if (accessInfo?.permissions?.includes(UserPermission.OnboardingView)) {
    return <Navigate to={ROUTES.CONTRACTOR_ONBOARDINGS_URL} />
  }

  return <Navigate to={ROUTES.CONTRACTORS_URL} />
}
